<template>
  <div>
    <title-header :pageTitle="pageTitle" :backTo="backTo"></title-header>
    <div class="flex-column">
      <router-view style="flex:1"></router-view>
      <copyright></copyright>
    </div>
  </div>
</template>

<script>
import TitleHeader from '@/components/layouts/TitleHeader';
import Copyright from '@/components/layouts/Copyright'

export default {
  name: 'TitleLayout',
  data () {
    return {
      pageTitle: '',
      backTo: ''
    }
  },
  components: { TitleHeader, Copyright },
  created () {
    this.getInfoPage(this.$route)
  },
  methods: {
    getInfoPage (route) {
      this.pageTitle = route.meta.pageTitle || ''
      this.backTo = route.meta.backTo || ''
    }
  },
  watch: {
    $route: function (to, from) {
      this.getInfoPage(to)
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/TitleLayout.vue